import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore"; // <-- 1. IMPORTANTE: Añadimos la base de datos

const firebaseConfig = {
  apiKey: "AIzaSyD0B4KdJuIxTGtNXHjpc14hcNzeF8bryRQ",
  authDomain: "blossom-and-bond-web.firebaseapp.com",
  projectId: "blossom-and-bond-web",
  storageBucket: "blossom-and-bond-web.firebasestorage.app",
  messagingSenderId: "770944336904",
  appId: "1:770944336904:web:97a7a2f891367f7ef3fdbd",
  measurementId: "G-W7RFMR9HYN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// 2. IMPORTANTE: Exportamos la base de datos para usarla en la web
export const db = getFirestore(app);

export default app;